import { reactive, ref, watch } from 'vue';
import type { Agent } from '@/types/agents';

interface DialogState {
  isOpen: boolean;
  agent: Agent | null;
  associateAthleteTwrn: string | null;
}

const getDefaultState = (): DialogState => ({
  isOpen: false,
  agent: null,
  associateAthleteTwrn: null,
});

const state = reactive(getDefaultState());

function resetState() {
  Object.assign(state, getDefaultState());
}

const isRendered = ref<boolean>(false);

watch(() => state.isOpen, (isOpen) => {
  if (isOpen && !isRendered.value) isRendered.value = true;
  if (!isOpen) resetState();
});

export function useCreateOrEditAgentDialog() {
  function open(agent?: Agent, associateAthleteTwrn?: string) {
    state.agent = agent ?? null;
    state.associateAthleteTwrn = associateAthleteTwrn ?? null;
    state.isOpen = true;
  }

  function close() {
    state.isOpen = false;
  }

  return {
    state,
    isRendered,
    resetState,
    open,
    close,
  };
}
